import { MaxUint256 } from '@ethersproject/constants'
import { useTranslation } from "@pancakeswap/localization"
import { useToast } from "@pancakeswap/uikit"
import { ToastDescriptionWithTx } from "components/Toast"
import { useCallWithMarketGasPrice } from "hooks/useCallWithMarketGasPrice"
import { useCsERC20 } from "hooks/useContract"
import { useCallback, useState } from "react"
import { useAppDispatch } from 'state'
import { fetchDataUser } from 'state/giftCards/actions'
import { fetchPublicDataUser } from 'state/giftCards/fetchData'


export const useApprove = (contractAddress, account, token, chainId, provider ) => {
    const { toastSuccess, toastError } = useToast()
    const { callWithMarketGasPrice } = useCallWithMarketGasPrice()
    const { t } = useTranslation()
    const address = useCsERC20(token?.address)
    const [ pendingTx, setPendingTx ] = useState(false)
    const dispatch = useAppDispatch()
    const handleApprove = useCallback(async () => {
      setPendingTx(true)
      try {
        const tx = await callWithMarketGasPrice(address, 'approve', [contractAddress, MaxUint256])
        const receipt = await tx.wait()
  
        if (receipt.status) {
          toastSuccess(
            t('Chấp thuận thành công'),
            <ToastDescriptionWithTx txHash={receipt.transactionHash}/>
          )
          
        } else {
          // user rejected tx or didn't go thru
          toastError(t('Đã xảy ra lỗi'), t('Vui lòng thử lại.'))
          setPendingTx(false)
        }
      } catch (e) {
        console.error(e)
        toastError(t('Đã xảy ra lỗi'), t('Vui lòng thử lại.'))
        setPendingTx(false)
      } finally {
        setPendingTx(false)
        const res = await fetchPublicDataUser(contractAddress, account, token, chainId, provider )
        dispatch(fetchDataUser(res))
      }
    }, [callWithMarketGasPrice, address, contractAddress, toastSuccess, t, toastError, account, token, chainId, provider, dispatch])
  
    return { handleApprove, pendingTx }
  }
  